<div class="container mx-auto px-4">
  <!-- Stripe mounts into this node, so it has to stay in the DOM. While it is
       empty, empty:hidden keeps it from occupying any space. -->
  <div id="stripe-notification-banner-mount" class="mt-4 empty:hidden"></div>

  @for (notification of groupJoinNotifications; track notification.id) {
    <div hlmAlert class="mt-4">
      <ng-icon name="lucideUsers" />
      <p hlmAlertTitle>{{ notification.title }}</p>
      <p hlmAlertDescription>{{ notification.message }}</p>
      <button hlmBtn variant="outline" size="sm" class="mt-2" (click)="goToGroup(notification)">
        Freigabe prüfen
        <ng-icon name="lucideArrowRight" data-icon="inline-end" />
      </button>
      <div hlmAlertAction>
        <button
          hlmBtn
          variant="ghost"
          size="icon-sm"
          aria-label="Schließen"
          (click)="dismissGroupJoinNotif(notification)">
          <ng-icon name="lucideX" />
        </button>
      </div>
    </div>
  }

  @if (showOnboardingSuccess) {
    <div hlmAlert class="mt-4">
      <ng-icon name="lucideCircleCheck" />
      <p hlmAlertTitle>Stripe Connect ist eingerichtet</p>
      <p hlmAlertDescription>
        Stripe wurde erfolgreich eingerichtet! Du kannst jetzt Zahlungen empfangen.
      </p>
      <div hlmAlertAction>
        <button
          hlmBtn
          variant="ghost"
          size="icon-sm"
          aria-label="Schließen"
          (click)="dismissOnboardingSuccess()">
          <ng-icon name="lucideX" />
        </button>
      </div>
    </div>
  }

  @if (showDoStripeSetup) {
    <div hlmAlert variant="warning" class="mt-4">
      <ng-icon name="lucideTriangleAlert" />
      <p hlmAlertTitle>Zahlungen nicht eingerichtet</p>
      <p hlmAlertDescription>
        Kunden können noch keine Gutscheine kaufen. Bitte schließe die Zahlungseinrichtung ab.
      </p>
      <button hlmBtn variant="outline" size="sm" class="mt-2" (click)="navigateToStripeSetup()">
        Jetzt einrichten
        <ng-icon name="lucideArrowRight" data-icon="inline-end" />
      </button>
    </div>
  }
</div>
